import { postTimelineExportStart } from '@api';

import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const postCoreTimelineExportSlice = createPostAsyncSlice({
	name: 'CoreTimelineExport',
	receive: true,
	request: true,
	requestHandler: postTimelineExportStart,
	retainDataOnRequest: false,
	yieldType: SagaYieldType.Every
});
